import { types as actionTypes } from './WaiverWorkItemDetailsActions';
import { Action } from '../../../types';
import { WaiverWorkItemDetails } from '../../../../types/waiverWorkItem';

export interface WaiverWorkItemDetailsState {
  loading: boolean;
  entity?: WaiverWorkItemDetails;
  error?: string;
}

const initialState: WaiverWorkItemDetailsState = {
  loading: false,
};

export default function reducer(
  state: WaiverWorkItemDetailsState = initialState,
  action: Action<WaiverWorkItemDetails>
): WaiverWorkItemDetailsState {
  switch (action.type) {
    case actionTypes.LOAD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: action.response,
      };
    case actionTypes.LOAD_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        entity: undefined,
        error: action.error ? action.error.message : 'Unknown error',
      };
    case actionTypes.LOAD_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error ? action.error.message : 'Unknown error',
      };
    case actionTypes.UPDATE:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.SNOOZE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.SNOOZE_NOTIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error ? action.error.message : 'Unknown error',
      };
    case actionTypes.SNOOZE_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
